export default "__VITE_ASSET__Cs15BkzP__"